import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { fmtUSD } from "../lib/format";
import { PageHeader, StatusBadge } from "../components/PageHeader";
import { DataTable } from "../components/DataTable";
import { Loader } from "../components/KpiCard";
import { Modal, Field, TextInput, SelectInput, AddButton } from "../components/Form";

const VTYPES = ["Supplier", "Contractor", "Consultant", "Utility", "Professional Services"];

export default function Vendors() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ vendor_name: "", vendor_type: "Supplier", contact_person: "", email: "", phone: "", w9_received: false, payment_terms: "Net 30" });

  const load = () => api.get("/vendors").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/vendors", { ...form, w9_received: form.w9_received === "true" || form.w9_received === true });
      toast.success("Vendor added");
      setOpen(false);
      setForm({ vendor_name: "", vendor_type: "Supplier", contact_person: "", email: "", phone: "", w9_received: false, payment_terms: "Net 30" });
      load();
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  if (!rows) return <Loader />;

  const columns = [
    { key: "vendor_name", label: "Vendor", className: "font-medium" },
    { key: "vendor_type", label: "Type", className: "text-[#5C5C54]" },
    { key: "contact_person", label: "Contact", className: "text-[#5C5C54]" },
    { key: "payment_terms", label: "Terms", className: "text-[#5C5C54]" },
    { key: "w9_received", label: "W-9", render: (r) => <StatusBadge tone={r.w9_received ? "green" : "red"}>{r.w9_received ? "On File" : "Missing"}</StatusBadge> },
    { key: "total_spending", label: "Total Spend", align: "right", render: (r) => fmtUSD(r.total_spending) },
  ];

  return (
    <div>
      <PageHeader title="Vendor Master" subtitle="Supplier records, compliance documentation and procurement spend."
        action={<AddButton onClick={() => setOpen(true)} label="New Vendor" testid="add-vendor-btn" />} />
      <DataTable columns={columns} rows={rows} testid="vendors-table" />

      <Modal open={open} onOpenChange={setOpen} title="New Vendor" onSubmit={submit} busy={busy} testid="vendor-modal">
        <Field label="Vendor Name" span={2}><TextInput required value={form.vendor_name} onChange={(e) => setForm({ ...form, vendor_name: e.target.value })} /></Field>
        <Field label="Type"><SelectInput value={form.vendor_type} onChange={(e) => setForm({ ...form, vendor_type: e.target.value })} options={VTYPES} /></Field>
        <Field label="W-9 Received"><SelectInput value={String(form.w9_received)} onChange={(e) => setForm({ ...form, w9_received: e.target.value })} options={[{ value: "false", label: "No" }, { value: "true", label: "Yes" }]} /></Field>
        <Field label="Contact Person"><TextInput value={form.contact_person} onChange={(e) => setForm({ ...form, contact_person: e.target.value })} /></Field>
        <Field label="Payment Terms"><SelectInput value={form.payment_terms} onChange={(e) => setForm({ ...form, payment_terms: e.target.value })} options={["Net 15", "Net 30", "Net 45", "Due on Receipt"]} /></Field>
        <Field label="Email"><TextInput type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Field>
        <Field label="Phone"><TextInput value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></Field>
      </Modal>
    </div>
  );
}
